import { render, staticRenderFns } from "./PageHistoricalFigure.vue?vue&type=template&id=7bd6f56a&"
import script from "./PageHistoricalFigure.vue?vue&type=script&lang=js&"
export * from "./PageHistoricalFigure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd6f56a')) {
      api.createRecord('7bd6f56a', component.options)
    } else {
      api.reload('7bd6f56a', component.options)
    }
    module.hot.accept("./PageHistoricalFigure.vue?vue&type=template&id=7bd6f56a&", function () {
      api.rerender('7bd6f56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/historicalFigure/PageHistoricalFigure.vue"
export default component.exports